import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "graphDownArrowWithDollarSign2",
    iconColor: "white",
    text: "60% reduction in OpEx",
    listItemCustomStyle: { width: "275px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "network",
    iconColor: "white",
    text: "AI/ML based predictions\n for network demand \nand capacity planning",
    listItemCustomStyle: { width: "293px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithCar",
    iconColor: "white",
    text: "3x faster plan \ncompletion cycle",
    listItemCustomStyle: { width: "auto" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_INLCM_1 = {
  title: "Network Planning Intelligence",
  titleNumber: "1.",
  text: "From blueprint to brilliance, precisely planning network paths and predicting \nfuture capacity demands, ensuring smooth information flow.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Next Lifecycle Stage",
    onClick: () => setCurrentPage("ENG_303"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_301"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_INTRO_02.jpg",
};
